import { Box } from '@mui/material';

import { FHAutocomplete, FHConfirmDialog } from '../../../../components/base';
import { BackgroundTypes } from '../../../../constants';
import { PROMOTE_ROLE_OPTIONS } from '../constants';
import {
  PROMOTE_DIALOG_CONTENT_SX,
  PROMOTE_DIALOG_SX,
  PROMOTE_ROLE_AUTOCOMPLETE_SX,
} from '../styles';
import { isPromoteRoleOptionDisabled } from '../utils';

import type { SyntheticEvent } from 'react';
import type { DialogProps } from '@mui/material';
import type { ISelectOption } from '../../../../utils/types';
import type { PromoteToClinicalDialogProps } from '../types';

export function PromoteToClinicalDialog({
  open,
  selectedRoles,
  onRolesChange,
  onClose,
  onSubmit,
}: PromoteToClinicalDialogProps) {
  const handleRolesChange = (_: SyntheticEvent, newValue: ISelectOption[]) => {
    onRolesChange(newValue);
  };

  const handleClose: NonNullable<DialogProps['onClose']> = (_event, reason) => {
    if (reason === 'backdropClick') return;
    onClose();
  };

  return (
    <FHConfirmDialog
      title="Promote provider to clinical"
      open={open}
      sx={PROMOTE_DIALOG_SX}
      contentRenderer={() => (
        <Box sx={PROMOTE_DIALOG_CONTENT_SX}>
          <FHAutocomplete
            multiple
            filterSelectedOptions
            sx={PROMOTE_ROLE_AUTOCOMPLETE_SX}
            coloredBackground
            backgroundType={BackgroundTypes.Colored}
            placeholder="Select role(s)"
            isOptionEqualToValue={(option: ISelectOption, val: ISelectOption) =>
              option.value === val.value
            }
            options={PROMOTE_ROLE_OPTIONS}
            value={selectedRoles}
            onChange={handleRolesChange}
            getOptionDisabled={(option: ISelectOption) =>
              isPromoteRoleOptionDisabled(option, selectedRoles)
            }
          />
        </Box>
      )}
      submittext="Promote"
      canceltext="Cancel"
      onClose={handleClose}
      onSubmit={onSubmit}
    />
  );
}
